import React, {useState, useEffect} from 'react';
import {useForm, FormProvider, Controller} from 'react-hook-form';
import {FormGroup} from 'react-bootstrap';
import {Row, Col} from 'react-bootstrap';
import InputDate from '../../../components/FormFields/inputDate/InputDate';
import SelectInfinite from '../../../components/FormFields/SelectInfinite';
import {getLanguage, t} from 'react-switch-lang';
import InputText from '../../../components/FormFields/InputText';
import * as yup from 'yup';
import {yupResolver} from '@hookform/resolvers';
import {validNumberRegex} from '../../../utils/const';
import {Spin} from 'antd';
import SelectList from '../../../components/FormFields/select/SelectList';

const RiskFilter = ({submit, activeTab, user, departments}) => {
  const [roleDisabled, setRoleDisabled] = useState(
    user.authorities.includes('ROLE_RISK_SECTOR')
  );
  const [defaultDepartment, setDefaultDepartment] = useState([]);
  const [loading, setLoading] = useState(true);
  const [departmentOptions, setDepartmentOptions] = useState([]);

  useEffect(() => {
    let arr = [];
    departments.map((item) => {
      arr.push({value: item.id, label: item.name});
    });
    setDepartmentOptions(arr);
  }, [departments]);

  useEffect(() => {
    const arr = [];
    departments.map((item, idx) => {
      arr.push({value: item.id, label: lang === 'mne' ? item.name : item.nameEn});
    });
    setDefaultDepartment(arr);
    setLoading(false);
  }, [departments]);
  const optionsTask = [
    {value: 'id', label: `${t('risk-cosideration.id')}`},
    {value: 'title', label: `${t('risk-cosideration.title')}`},
    {value: 'estimation', label: `${t('risk-cosideration.estimation')}`},
  ];

  const [schema, setSchema] = useState(
    yup.object().shape({
      id: yup.object().nullable(),
      riskEstimationId: yup.object().nullable(),
    })
  );
  const lang = getLanguage();

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch, setValue, reset} = methods;
  const validFrom = watch('dateCreated');
  const validTo = watch('dateUpdated');
  const select = watch('selectRisk');
  const departmentWatch = watch('department');

  useEffect(() => {
    if (select?.value === 'id' || select?.value === 'estimation') {
      setSchema(
        yup.object().shape({
          searchInput: yup
            .string()
            .trim()
            .matches(validNumberRegex, t('message.onlyNumbers')),
        })
      );
    } else {
      setSchema(
        yup.object().shape({
          searchInput: yup.string().trim(),
        })
      );
    }
  }, [select]);

  useEffect(() => {
    if (
      activeTab === 'occured' &&
      departmentWatch === null &&
      roleDisabled === false
    ) {
      setValue('department', defaultDepartment);
    }
    if (
      activeTab === 'litigation' &&
      departmentWatch === null &&
      roleDisabled === false
    ) {
      setValue('department', defaultDepartment);
    }
  }, [departmentWatch]);

  return (
    <>
      {loading ? (
        <Spin spinning={loading} size={'large'} className="spinner" />
      ) : (
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(submit)}>
            <Row className="main-container pt-5 m-0">
              <div className="w-100 wrapper d-flex justify-content-between">
                <div className="wrapper__left pr-4 d-flex">
                  <div className="wrapper__left--30 d-flex">
                    <div className="search-header w-100">
                      <InputText
                        type="text"
                        name="searchInput"
                        className="search-input"
                        placeholder={t('risk-cosideration.search.search-input')}
                      />
                      <SelectInfinite
                        name="selectRisk"
                        className="select-options"
                        options={optionsTask}
                        isClearable={true}
                        placeholder={t('placeholder.select')}
                      />
                    </div>
                  </div>

                  <div className="wrapper__left--70 d-flex">
                    <div className="w-50 d-flex">
                      <div className="w-50 d-flex">
                        <FormGroup
                          className="date-validation ml-4 mr-2"
                          name="validTo"
                          label=""
                        >
                          <InputDate
                            name="dateCreated"
                            maxDate={validTo}
                            isClearable
                            placeholderText={t(
                              'risk-cosideration.search.dateFrom'
                            )}
                          />
                        </FormGroup>
                      </div>
                      <div className="w-50 d-flex">
                        <FormGroup
                          className="date-validation mr-4"
                          name="validForm"
                          label=""
                        >
                          <InputDate
                            name="dateUpdated"
                            minDate={validFrom}
                            isClearable
                            placeholderText={t(
                              'risk-cosideration.search.dateTo'
                            )}
                          />
                        </FormGroup>
                      </div>
                    </div>
                    <div className="w-50 d-flex justify-content-end">
                    <FormGroup
                        className="date-validation"
                        name=""
                        label=""
                      >
                      {activeTab === 'potential-risks' ? (
                        <SelectInfinite
                          api="/departments"
                          name="department"
                          labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                          className="department"
                          placeholder={t(
                            'risk-cosideration.search.organizedUnit'
                          )}
                          defaultValue={defaultDepartment}
                          isMulti={true}
                          isClearable={true}
                        />
                      ) : roleDisabled === true ? (
                        <SelectInfinite
                          api="/departments"
                          name="department"
                          labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                          className="department"
                          placeholder={t(
                            'risk-cosideration.search.organizedUnit'
                          )}
                          defaultValue={defaultDepartment}
                          isMulti={true}
                          isClearable={true}
                        />
                      ) : (
                        <SelectList
                          name="department"
                          defaultValue={defaultDepartment}
                          placeholder={t(
                            'risk-cosideration.search.organizedUnit'
                          )}
                          options={departmentOptions}
                          isClearable={false}
                          isMulti
                        />
                      )}
                      </FormGroup>
                    </div>
                  </div>
                </div>
                <div className="wrapper__right">
                  <button
                    className="float-right primary-btn search-button "
                    disabled={false}
                    type="submit"
                  >
                    {t('risk-cosideration.search.searchButton')}
                  </button>
                </div>
              </div>
            </Row>
          </form>
        </FormProvider>
      )}
    </>
  );
};
export default RiskFilter;
